import React from 'react';
import Card from './Card.js'
import {
  bordado,
  aplicacao,
  artes_graficas,
  decoracao,
  estampagem,
  impressao_digital,
  offset,
  serigrafia,
  criacao_digital,
} from '../../sharedcomponents/ImageScope'


import './Cards.css'

export default function Cards(){
  return(
    <div className="Cards_main">
       <Card CardService_title={"Aplicação"} CardService_background={aplicacao} />
       <Card CardService_title={"Criação Gráfica"} CardService_background={artes_graficas}/>
       <Card CardService_title={"Bordado"} CardService_background={bordado}/>
       <Card CardService_title={"Impressão Digital"} CardService_background={impressao_digital}/>
       <Card CardService_title={"Estampagem"} CardService_background={estampagem}/>
       <Card CardService_title={"Decoração"} CardService_background={decoracao}/>
       <Card CardService_title={"Offset"} CardService_background={offset}/>
       <Card CardService_title={"Criação Digital"} CardService_background={criacao_digital}/>
       <Card CardService_title={"Sirigrafia"} CardService_background={serigrafia}/>
    </div>
  );
}